import React, { useState } from "react";
import Modal from "./Modal.tsx";
import StyledButton from "./Button.tsx";
import {
  ModalInput,
  ModalLabel,
  ModalButtonRow,
  CancelButton,
  ErrorMessage,
} from "./ModalFormComponents.tsx";
import { addFolder } from "../services/categories.service.ts";
import { parseApiError } from "../utils/errorHandler.ts";

interface AddFolderModalProps {
  isOpen: boolean;
  onClose: () => void;
  categoryId: number;
  parentNodeId?: number | null;
  categoryType?: string;
  onSuccess?: () => void;
}

export default function AddFolderModal({
  isOpen,
  onClose,
  categoryId,
  parentNodeId,
  categoryType,
  onSuccess,
}: AddFolderModalProps) {
  const [folderName, setFolderName] = useState("");
  const [folderDescription, setFolderDescription] = useState("");
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleClose = () => {
    setFolderName("");
    setFolderDescription("");
    setError(null);
    onClose();
  };

  const handleSubmit = async () => {
    setError(null);

    if (!folderName.trim()) {
      setError("Mappe navn er påkrævet");
      return;
    }

    setCreating(true);
    try {
      await addFolder(categoryId, {
        parentNodeId,
        categoryType,
        name: folderName.trim(),
        description: folderDescription.trim() || undefined,
      });

      handleClose();
      onSuccess?.();
    } catch (err: any) {
      setError(parseApiError(err));
    } finally {
      setCreating(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Tilføj mappe">
      {error && <ErrorMessage>{error}</ErrorMessage>}

      <ModalLabel>Mappe navn *</ModalLabel>
      <ModalInput
        placeholder="f.eks. Manualer"
        value={folderName}
        onChange={(e) => setFolderName(e.target.value)}
        style={{ marginBottom: "0.75rem" }}
      />

      <ModalLabel>Beskrivelse</ModalLabel>
      <ModalInput
        placeholder="Beskrivelse (valgfrit)"
        value={folderDescription}
        onChange={(e) => setFolderDescription(e.target.value)}
      />

      <ModalButtonRow>
        <CancelButton onClick={handleClose}>Annuller</CancelButton>
        <StyledButton onClick={handleSubmit} disabled={creating}>
          {creating ? "Tilføjer..." : "Tilføj mappe"}
        </StyledButton>
      </ModalButtonRow>
    </Modal>
  );
}
